import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTenantService } from 'hooks/api/iam/tenant';
import { truncateText } from 'app/shared/utils/general';
import WebDataTable from 'app/shared/datatable/web/datatable';

export const TenantUsers = () => {
  const { id } = useParams();
  const tenant_id = id;
  const { fetchMemberships } = useTenantService();

  const [users, setUsers] = useState([]);
  const [is_search_mode] = useState(false);
  const [loading] = useState(false);
  const [page_window, setPageWindow] = useState({ page: 0, population: 10 });

  useEffect(() => {
    const loadUsers = async () => {
      const { memberships } = await fetchMemberships(tenant_id);
      const fetchedUsers = memberships.map((members) => ({
        ...members.user,
        updated_on: members.updated_on,
        email: members.user_email
      }));
      setUsers(fetchedUsers);
    };

    if (tenant_id) {
      loadUsers();
    }
  }, [tenant_id]);

  const config = {
    actions: {
      single: () => [
        [
          { label: 'Deactivate', value: 'deactivate' },
          { label: 'Update Earnings %', value: 'update_earning_percent' }
        ]
      ]
    },
    allow_bulk_action: true,
    css: {},
    fields: [
      {
        title: 'ID',
        key: 'id',
        isTitle: true,
        formatter: (value) => value
      },
      {
        title: 'First name',
        key: 'firstname',
        isTitle: true,
        searchable: true,
        formatter: (value) => truncateText(value, 40)
      },
      {
        title: 'Last name',
        key: 'lastname',
        isTitle: true,
        searchable: true,
        formatter: (value) => truncateText(value, 40)
      },
      {
        title: 'Email Address',
        key: 'email',
        isTagline: true,
        searchable: true,
        formatter: (value) => truncateText(value, 40)
      },
      {
        title: 'Modified On',
        key: 'updated_on',
        formatter: (value) => new Date(value).toDateString(),
        isMetadata: true
      }
    ],
    is_search_mode,
    items: users.sort((a, b) => b.id - a.id),
    search_key: 'name',
    search_text: ''
  };

  const page_items = users.slice(
    page_window.page * page_window.population,
    (page_window.page + 1) * page_window.population
  );

  return (
    <div>
      <WebDataTable
        config={{
          ...config,
          is_search_mode,
          items: page_items,
          total_count: users.length
        }}
        checkbox
        loading_data={loading}
        onDataRequest={(page = 0, population = 10) => setPageWindow({ page, population })}
      />
    </div>
  );
};
